module.exports = __webpack_public_path__ + "img/info-white.a82faa51.svg";